/* This code is checking if the current environment is a browser environment or not. It exports a
boolean value `canUseDom` which is true if the current environment has a `window` object, a
`document` object, and a `createElement` method on the `document` object. The double negation `!!`
is used to convert the result of the expression into a boolean value. */
export const canUseDom = !!(
  typeof window !== "undefined" &&
  typeof window.document !== "undefined" &&
  typeof window.document.createElement !== "undefined"
)
